module.exports = __webpack_public_path__ + "static/img/how5.07cdd9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/how5.png
// module id = gnvd
// module chunks = 1